const CollapseStates = {
    NEUTRAL: 0,
    MAX: 1,
    MIN: -1
};

export const sortPanel = ['$timeout', '$compile', ($timeout, $compile) => {
    const parentReset = ((scope) => {
        return () => {
            scope.isCollapsedSelected = true;
            scope.isCollapsedAvailable = true;
            const lastQuarter = 3;
            const firstQuarter = 1;
            let splitAreaSelectedPackages = angular.element(`#${scope.splitUp}`);
            let splitAreaAvailablePackages = angular.element(`#${scope.splitDown}`);
            let selectedHeight = splitAreaSelectedPackages.height(), availableHeight = splitAreaAvailablePackages.height();
            if (selectedHeight == availableHeight) {
                scope.btnCollapseStates.down.state = CollapseStates.NEUTRAL;
                scope.btnCollapseStates.up.state = CollapseStates.NEUTRAL;
            }
            else
                if (selectedHeight == scope.minSplitSize) {
                    scope.btnCollapseStates.down.state = CollapseStates.MIN;
                    scope.btnCollapseStates.up.state = CollapseStates.MAX;
                }
                else
                    if (availableHeight == scope.minSplitSize) {
                        scope.btnCollapseStates.down.state = CollapseStates.MAX;
                        scope.btnCollapseStates.up.state = CollapseStates.MIN;
                    }
                    else
                        if ((selectedHeight / availableHeight) > lastQuarter) {
                            scope.btnCollapseStates.down.state = CollapseStates.NEUTRAL;
                            scope.btnCollapseStates.up.state = CollapseStates.MIN;
                        }
                        else
                            if ((availableHeight / selectedHeight) > lastQuarter) {
                                scope.btnCollapseStates.down.state = CollapseStates.MIN;
                                scope.btnCollapseStates.up.state = CollapseStates.NEUTRAL;
                            }
                            else
                                if ((availableHeight / selectedHeight) > firstQuarter) {
                                    scope.btnCollapseStates.down.state = CollapseStates.MIN;
                                    scope.btnCollapseStates.up.state = CollapseStates.NEUTRAL;
                                }
                                else if ((selectedHeight / availableHeight) > firstQuarter) {
                                    scope.btnCollapseStates.down.state = CollapseStates.NEUTRAL;
                                    scope.btnCollapseStates.up.state = CollapseStates.MIN;
                                }
        }
    });

    const onCollapse = (pressed, scope) => {
        const collpaseState = () => {
            let splitAreaSelectedPackages = angular.element(`#${scope.splitUp}`)
            let splitAreaAvailablePackages = angular.element(`#${scope.splitDown}`)
            if (scope.btnCollapseStates.down.state === CollapseStates.NEUTRAL || scope.btnCollapseStates.up.state === CollapseStates.NEUTRAL) {
                splitAreaSelectedPackages.css('height', 'calc(50% - 2.5px)');
                splitAreaAvailablePackages.css('height', 'calc(50% - 2.5px)');
                return { selected: true, available: true };
            }
            if (scope.btnCollapseStates.down.state === CollapseStates.MAX) {
                splitAreaSelectedPackages.css('height', 'calc(93% - 2.5px)');
                splitAreaAvailablePackages.css('height', 'calc(7% - 2.5px)');
                return { selected: true, available: false };
            }
            if (scope.btnCollapseStates.up.state === CollapseStates.MAX) {
                splitAreaSelectedPackages.css('height', 'calc(7% - 2.5px)');
                splitAreaAvailablePackages.css('height', 'calc(93% - 2.5px)');
                return { selected: false, available: true };
            }
        };
        $timeout(() => {
            let runCollapse = false;
            if (pressed === 'up' && scope.btnCollapseStates.up.state < CollapseStates.MAX) {
                scope.btnCollapseStates.up.state += 1;
                scope.btnCollapseStates.down.state -= 1;
                runCollapse = true;
            } else if (pressed === 'down' && scope.btnCollapseStates.down.state < CollapseStates.MAX) {
                scope.btnCollapseStates.down.state += 1;
                scope.btnCollapseStates.up.state -= 1;
                runCollapse = true;
            }
            if (runCollapse === true) {
                let result = collpaseState();
                if (result) {
                    scope.isCollapsedUp = result.selected;
                    scope.isCollapsedDown = result.available;
                }
            }
        }, 200);
    };

    return {
        restrict: 'A',
        replace: false,
        transclude: false,
        scope: {
            splitUp: '@',
            splitDown: '@',
            isCollapsedUp: '=',
            isCollapsedDown: '=',
            resestCollapsible: '=',
            minSplitSize: '@'
        },
        link: function (scope, element, attrs) {
            $timeout(function () {
                scope.btnCollapseStates = {
                    up: { state: CollapseStates.NEUTRAL },
                    down: { state: CollapseStates.NEUTRAL }
                };
                scope.onCollapse = onCollapse;
                scope.scope = scope;
                let gutter = element.querySelectorAll(".gutter");
                let arr = [];
                scope.available = false;
                scope.selected = false;
                scope.resestCollapsible = parentReset(scope);
                arr.push('<div style="display:flex;justify-content:center;position:relative;top:-5px;z-index:999">');
                arr.push(`<div role= "button" class="dbm dbm-back-icon down"  style= "margin-right:50px"  ng-click="onCollapse('down', this)" ></div>`);
                arr.push(`<div role= "button" class="dbm dbm-back-icon up"  ng-click="onCollapse('up', this)" ></div>`);
                arr.push('</div>');
                $compile(arr.join(''))(scope).appendTo(gutter);
            }, 0);
        }
    };
}];

export class SortPanelCollapsible {
    constructor() {
        this.reset = null;
    }

    resetCollapsible = () => {
        if (typeof this.reset === 'function') {
            this.reset();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/sortPanel.js